/**
 * Acquire a key for an asynchronous operation. The mutable Set belongs in a
 * ref so the guard takes effect synchronously, before React can render a
 * disabled control.
 */
export function tryAcquireInFlightKey(keys: Set<string>, key: string): boolean {
  if (keys.has(key)) return false;
  keys.add(key);
  return true;
}

export function releaseInFlightKey(keys: Set<string>, key: string): void {
  keys.delete(key);
}
